import { render, staticRenderFns } from "./DetailsDialog.vue?vue&type=template&id=72878c4c"
import script from "./DetailsDialog.vue?vue&type=script&lang=js"
export * from "./DetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailsDialog.vue?vue&type=style&index=0&id=72878c4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports